import gql from 'graphql-tag';

export const SECRETARY_OF_STATE_VIEW_FRAGMENT = gql`
  fragment SecretaryOfStateViewViewModel on SecretaryOfStateView {
    badge {
      label
      variant
    }
    entity {
      name
      sosLabel
      initials
      profileUrl
      filingNumber
    }
    fields {
      label
      value
    }
    status
    warning
  }
`;

export const SECRETARY_OF_STATE_REPORT_FRAGMENT = gql`
  ${SECRETARY_OF_STATE_VIEW_FRAGMENT}
  fragment SecretaryOfStateReportViewModel on SecretaryOfStateReportViewModel {
    id
    view {
      ...SecretaryOfStateViewViewModel
    }
    data {
      key
      label
      value
    }
    createdDateTime
    createdBy {
      id
      fullName
    }
  }
`;

export const SECRETARY_OF_STATE_LAST_REPORT_FRAGMENT = gql`
  ${SECRETARY_OF_STATE_VIEW_FRAGMENT}
  fragment SecretaryOfStateLastReportViewModel on SecretaryOfStateLastReportViewModel {
    id
    view {
      ...SecretaryOfStateViewViewModel
    }
    data {
      key
      label
      value
    }
    nextAvailableAt
    createdDateTime
    canGenerateReport
    createdBy {
      id
      fullName
    }
  }
`;
